import { ObjectSchema } from 'yup';
import Yup from '../../../../../services/common/validation';
import { CompanyDetailsFormModel_OB_FP } from './formModel';

export const getValidationSchema = (): ObjectSchema<Partial<CompanyDetailsFormModel_OB_FP>> => {
  /* TODO: Replace below placeholder when FP product is brought back */
  return Yup.object({
    identityType: Yup.string() as any,
    identityNumber: Yup.string() as any,
    croNumber: Yup.string() as any,
    registeredPartnershipName: Yup.string() as any,
    entityForm: Yup.string() as any,
    businessType: Yup.string() as any,
    businessSubType: Yup.string() as any,
    institutionalType: Yup.string() as any,
    enterpriseSize: Yup.string() as any,
    telephoneType: Yup.string() as any,
    countryCode: Yup.string() as any,
    correspondenceMethod: Yup.string() as any,
    dateOfIncorporation: Yup.string() as any,
    vatNumber: Yup.string() as any,
    annualProfitCurrentYear: Yup.string() as any,
    annualProfitPreviousYear: Yup.string() as any,
    currentBusinessContracts: Yup.string() as any,
    businessHistory: Yup.string() as any,
    phoneNumber: Yup.string() as any,
    companyEmail: Yup.string() as any,
    contactFirstName: Yup.string() as any,
    contactLastName: Yup.string() as any,
    contactPosition: Yup.string() as any,
    contactCountryCode: Yup.string() as any,
    contactPhoneNumber: Yup.string() as any,
  });
};
